"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageHelper = exports.generateUUID = exports.createSearchString = exports.createSearchObject = exports.joinStr = void 0;
const storage_1 = __importDefault(require("./helpers/storage"));
const uuidv4 = require('uuid/v4');
/**
 * Joins strings with a character.
 * @param {string | {char: string}} config - The first optional can optional be a config to change the joining character.
 * by defaults it joins with a space
 * @param {string} args - The rest of the args should be strings and are spread into a variable
 */
const joinStr = (config, ...args) => {
    let char = ' ';
    const values = args;
    if (typeof config === 'object') {
        ({ char } = config);
    }
    else {
        values.unshift(config);
    }
    return values.reduce((acc, curr, idx) => {
        let newValue = acc;
        if (curr) {
            if (idx === 0) {
                newValue = curr;
            }
            else {
                newValue = `${acc}${char}${curr}`;
            }
        }
        return newValue;
    }, '');
};
exports.joinStr = joinStr;
/**
 * Decodes a query string into an object
 * @param {string} query - Query string
 */
const createSearchObject = (query) => {
    const pathArray = query.replace('?', '').split('&');
    const locationObj = {};
    pathArray.forEach((keyValuePair) => {
        const [key, value] = keyValuePair.split('=');
        if (key && value) {
            locationObj[key] = value;
        }
    });
    return locationObj;
};
exports.createSearchObject = createSearchObject;
/**
 * Formats an object into a query string
 * @param { {[key: string]: string} } config - Object with json serializable values to be turned into a query string
 */
const createSearchString = (obj) => {
    if (Object.keys(obj).length) {
        const params = Object.entries(obj).map(([key, val]) => typeof val === 'string' ? `${key}=${val}` : null);
        return `?${(0, exports.joinStr)({ char: '&' }, ...params)}`;
    }
    return '';
};
exports.createSearchString = createSearchString;
const generateUUID = () => uuidv4();
exports.generateUUID = generateUUID;
exports.StorageHelper = storage_1.default;
